import React from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const Vip = () => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={3} style={{ padding: 24 }}>
      <Helmet>
        <title>{t('vipPage.pageTitle')}</title>
        <meta name="description" content={t('vipPage.metaDescription')} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Typography variant="h4" component="h2" gutterBottom>
      {t('vipPage.title')}
      </Typography>
    </Grid>
  );
};

export default Vip;
